import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { store } from './store/store'


import axios from 'axios'
Vue.prototype.$http = axios

Vue.config.productionTip = false

import routes from './routes'
Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history', routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});

export const serverBus = new Vue();


new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');